/**
 * Utility Methods
 */

import jQuery from "jquery";

export var FavoritesLib = FavoritesLib || {};

FavoritesLib.Utilities = function () {
  var plugin = this;
  var $ = jQuery;

  /*
   * Check if an item is favorited
   * @param int post_id
   * @param object favorites for a specific site
   */
  plugin.isFavorite = function (post_id, site_favorites) {
    var status = false;
    $.each(site_favorites, function (i, v) {
      if (v.post_id === parseInt(post_id)) status = true;
      if (parseInt(v.post_id) === post_id) status = true;
    });
    return status;
  };

  /**
   * Get the length of an
   */
  plugin.objectLength = function (object) {
    var size = 0,
      key;
    for (key in object) {
      if (object.hasOwnProperty(key)) size++;
    }
    return size;
  };

  /*
   * Get Site index from All Favorites
   */
  plugin.siteIndex = function (siteid) {
    for (var i = 0; i < FavoritesLib.userFavorites.length; i++) {
      if (FavoritesLib.userFavorites[i].site_id !== parseInt(siteid)) continue;
      return i;
    }
  };

  /*
   * Get a specific thumbnail size
   */
  plugin.getThumbnail = function (favorite, size) {
    var thumbnails = favorite.thumbnails;
    if (typeof thumbnails === "undefined" || thumbnails.length == 0)
      return false;
    var thumbnail_url = thumbnails[size];
    if (typeof thumbnail_url === "undefined") return false;
    if (!thumbnail_url) return false;
    return thumbnail_url;
  };
};
/**
 * Formatting functionality
 */
var FavoritesLib = FavoritesLib || {};

FavoritesLib.Formatter = function () {
  var plugin = this;
  var $ = jQuery;

  /*
   *  Add Favorite Count to a button
   */
  plugin.addFavoriteCount = function (html, count) {
    if (!FavoritesLib.jsData.button_options.include_count) return html;
    if (count <= 0) count = 0;
    html += ' <span class="simplefavorite-button-count">' + count + "</span>";
    return html;
  };

  /**
   * Decrement all counts by one
   */
  plugin.decrementAllCounts = function () {
    var buttons = $(".simplefavorite-button.active.has-count");
    for (var i = 0; i < buttons.length; i++) {
      var button = $(buttons)[i];
      var count_display = $(button).find(".simplefavorite-button-count");
      var new_count = $(count_display).text() - 1;
      $(button).attr("data-favoritecount", new_count);
    }
  };
};
/**
 * Builds the favorite button html
 */
var FavoritesLib = FavoritesLib || {};

FavoritesLib.ButtonOptionsFormatter = function () {
  var plugin = this;
  var $ = jQuery;

  plugin.options = FavoritesLib.jsData.button_options;
  plugin.formatter = new FavoritesLib.Formatter();

  /**
   * Format the button according to plugin options
   */
  plugin.format = function (button, isFavorite) {
    if (plugin.options.custom_colors) plugin.colors(button, isFavorite);
    plugin.html(button, isFavorite);
  };

  /**
   * Set the HTML content for the button
   */
  plugin.html = function (button, isFavorite) {
    var count = $(button).attr("data-favoritecount");
    var options = plugin.options.button_type;
    var html = "";
    if (plugin.options.button_type === "custom") {
      // if (isFavorite) $(button).removeClass("knapinaktiv").addClass("knapaktiv");
      // if (isFavorite) $(button).html(plugin.formatter.addFavoriteCount(Favorites.jsData.favorited, count));
      // if (!isFavorite) $(button).removeClass("knapaktiv").addClass("knapinaktiv");
      // if (!isFavorite) $(button).html(plugin.formatter.addFavoriteCount(Favorites.jsData.favorite, count));
      plugin.applyIconColor(button, isFavorite);
      plugin.applyCountColor(button, isFavorite);
      return;
    }
    if (isFavorite) {
      html += '<i class="' + options.icon_class + '"></i> ';
      html += options.state_active;
      // $(button).html(plugin.formatter.addFavoriteCount(html, count));
      return;
    }
    html += '<i class="' + options.icon_class + '"></i> ';
    html += options.state_default;
    // $(button).html(plugin.formatter.addFavoriteCount(html, count));
    plugin.applyIconColor(button, isFavorite);
    plugin.applyCountColor(button, isFavorite);
  };

  /**
   * Apply custom colors to the button if the option is selected
   */
  plugin.colors = function (button, isFavorite) {
    if (!plugin.options.custom_colors) return;
    if (isFavorite) {
      var options = plugin.options.active;
      if (options.background_active)
        $(button).css("background-color", options.background_active);
      if (options.border_active)
        $(button).css("border-color", options.border_active);
      if (options.text_active) $(button).css("color", options.text_active);
      return;
    }
    var options = plugin.options.default;
    if (options.background_default)
      $(button).css("background-color", options.background_default);
    if (options.border_default)
      $(button).css("border-color", options.border_default);
    if (options.text_default) $(button).css("color", options.text_default);
    plugin.boxShadow(button);
  };

  /**
   * Remove the box shadow from the button if the option is selected
   */
  plugin.boxShadow = function (button) {
    if (plugin.options.box_shadow) return;
    $(button).css("box-shadow", "none");
    $(button).css("-webkit-box-shadow", "none");
    $(button).css("-moz-box-shadow", "none");
  };

  /**
   * Apply custom colors to the icon if the option is selected
   */
  plugin.applyIconColor = function (button, isFavorite) {
    if (!plugin.options.custom_colors) return;
    if (isFavorite && plugin.options.active.icon_active) {
      $(button).find("i").css("color", plugin.options.active.icon_active);
    }
    if (!isFavorite && plugin.options.default.icon_default) {
      $(button).find("i").css("color", plugin.options.default.icon_default);
    }
  };

  /**
   * Apply custom colors to the favorite count if the option is selected
   */
  plugin.applyCountColor = function (button, isFavorite) {
    if (!plugin.options.custom_colors) return;
    if (isFavorite && plugin.options.active.count_active) {
      $(button)
        .find(FavoritesLib.selectors.count)
        .css("color", plugin.options.active.count_active);
      return;
    }
    if (!isFavorite && plugin.options.default.count_default) {
      $(button)
        .find(FavoritesLib.selectors.count)
        .css("color", plugin.options.default.count_default);
    }
  };
};
/**
 * Gets the user favorites
 */
var FavoritesLib = FavoritesLib || {};

FavoritesLib.UserFavorites = function () {
  var plugin = this;
  var $ = jQuery;

  plugin.initialLoad = false;

  plugin.bindEvents = function () {
    plugin.initialLoad = true;
    plugin.getFavorites();
  };

  /**
   * Get the user favorites
   */
  plugin.getFavorites = function () {
    const timeout = 10000;
    const fetchAbortController = new AbortController();
    const fetchAboutTimeout = setTimeout(
      () => fetchAbortController.abort(),
      timeout
    );
    fetch(FavoritesLib.jsData.ajaxurl, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      signal: fetchAbortController.signal,
      body: new URLSearchParams({
        action: FavoritesLib.formActions.favoritesarray,
      }),
    })
      .then((response) => response.json())
      .then(function (data) {
        clearTimeout(fetchAboutTimeout);

        if (FavoritesLib.jsData.dev_mode) {
          console.log("The current user favorites were successfully loaded.");
          console.log(data);
        }
        FavoritesLib.userFavorites = data.favorites;

        const favoritesInitialized = new CustomEvent("favorites-initialized", {
          detail: {
            favorites: [...Object.values(data.favorites[0].posts)],
            initialLoad: plugin.initialLoad,
          },
        });

        document.dispatchEvent(favoritesInitialized);

        $(document).trigger("favorites-user-favorites-loaded", [
          data.favorites,
          plugin.initialLoad,
        ]);
        $(document).trigger("favorites-update-all-buttons");
      })
      .catch(function (error) {
        // if (!Favorites.jsData.dev_mode) return;
        console.log("The was an error loading the user favorites.");
        console.log(error);
      });
  };

  return plugin.bindEvents();
};
/**
 * Clears all favorites for the user
 *
 * Events:
 * favorites-cleared: The user's favorites have been cleared. Params: clear button
 */
var FavoritesLib = FavoritesLib || {};

FavoritesLib.Clear = function () {
  var plugin = this;
  var $ = jQuery;

  plugin.activeButton; // The active "clear favorites" button
  plugin.utilities = new FavoritesLib.Utilities();
  plugin.formatter = new FavoritesLib.Formatter();

  plugin.bindEvents = function () {
    $(document).on("click", FavoritesLib.selectors.clear_button, function (e) {
      e.preventDefault();
      plugin.activeButton = $(this);
      plugin.clearFavorites();
    });
    $(document).on("favorites-updated-single", function () {
      plugin.updateClearButtons();
    });
    $(document).on("favorites-user-favorites-loaded", function () {
      plugin.updateClearButtons();
    });
  };

  /*
   * Submit an AJAX request to clear all of the user's favorites
   */
  plugin.clearFavorites = function () {
    plugin.loading(true);
    var site_id = $(plugin.activeButton).attr("data-siteid");
    $.ajax({
      url: FavoritesLib.jsData.ajaxurl,
      type: "post",
      datatype: "json",
      data: {
        action: FavoritesLib.formActions.clearall,
        siteid: site_id,
      },
      success: function (data) {
        if (FavoritesLib.jsData.dev_mode) {
          console.log("Favorites list successfully cleared.");
          console.log(data);
        }
        FavoritesLib.userFavorites = data.favorites;
        plugin.formatter.decrementAllCounts();
        plugin.loading(false);
        plugin.clearSiteFavorites(site_id);
        $(document).trigger("favorites-cleared", [
          plugin.activeButton,
          data.old_favorites,
        ]);
        $(document).trigger("favorites-update-all-buttons");
      },
      error: function (data) {
        if (!FavoritesLib.jsData.dev_mode) return;
        console.log("There was an error clearing the favorites list.");
        console.log(data);
      },
      timeout: 10000, // sets timeout to 5 seconds
    });
  };

  /**
   * Toggle the button loading state
   */
  plugin.loading = function (loading) {
    if (loading) {
      $(plugin.activeButton).addClass(FavoritesLib.cssClasses.loading);
      $(plugin.activeButton).attr("disabled", "disabled");
      return;
    }
    $(plugin.activeButton).removeClass(FavoritesLib.cssClasses.loading);
  };

  /*
   * Update disabled status for clear buttons
   */
  plugin.updateClearButtons = function () {
    var button;
    var siteid;
    for (var i = 0; i < $(FavoritesLib.selectors.clear_button).length; i++) {
      button = $(FavoritesLib.selectors.clear_button)[i];
      siteid = $(button).attr("data-siteid");
      for (var c = 0; c < FavoritesLib.userFavorites.length; c++) {
        if (FavoritesLib.userFavorites[c].site_id !== parseInt(siteid))
          continue;
        if (
          plugin.utilities.objectLength(FavoritesLib.userFavorites[c].posts) > 0
        ) {
          $(button).attr("disabled", false);
          continue;
        }
        $(button).attr("disabled", "disabled");
      }
    }
  };

  /**
   * Clear out favorites for this site id (fix for cookie-enabled sites)
   */
  plugin.clearSiteFavorites = function (site_id) {
    $.each(FavoritesLib.userFavorites, function (i, v) {
      if (this.site_id !== parseInt(site_id)) return;
      FavoritesLib.userFavorites[i].posts = {};
    });
  };

  return plugin.bindEvents();
};
/**
 * Favorites List functionality
 */
var FavoritesLib = FavoritesLib || {};

FavoritesLib.Lists = function () {
  var plugin = this;
  var $ = jQuery;

  plugin.utilities = new FavoritesLib.Utilities();
  plugin.buttonFormatter = new FavoritesLib.ButtonOptionsFormatter();

  plugin.bindEvents = function () {
    $(document).on("favorites-update-all-lists", function () {
      plugin.updateAllLists();
    });
    $(document).on("favorites-updated-single", function () {
      plugin.updateAllLists();
    });
    $(document).on("favorites-cleared", function () {
      plugin.updateAllLists();
    });
    $(document).on("favorites-user-favorites-loaded", function () {
      plugin.updateAllLists();
    });
  };

  /**
   * Loop through all the favorites lists
   */
  plugin.updateAllLists = function () {
    if (typeof FavoritesLib.userFavorites === "undefined") return;
    for (var i = 0; i < FavoritesLib.userFavorites.length; i++) {
      var lists = $(
        FavoritesLib.selectors.list +
          '[data-siteid="' +
          FavoritesLib.userFavorites[i].site_id +
          '"]'
      );
      for (var c = 0; c < $(lists).length; c++) {
        var list = $(lists)[c];
        plugin.updateSingleList(list);
      }
    }
  };

  /**
   * Update a specific user list
   */
  plugin.updateSingleList = function (list) {
    var user_id = $(list).attr("data-userid");
    var site_id = $(list).attr("data-siteid");
    var include_links = $(list).attr("data-includelinks");
    var include_buttons = $(list).attr("data-includebuttons");
    var include_thumbnails = $(list).attr("data-includethumbnails");
    var thumbnail_size = $(list).attr("data-thumbnailsize");
    var include_excerpt = $(list).attr("data-includeexcerpts");
    var post_types = $(list).attr("data-posttyper");
    var no_favorites = $(list).attr("data-nofavoritestext");

    $.ajax({
      url: FavoritesLib.jsData.ajaxurl,
      type: "post",
      dataType: "json",
      data: {
        action: FavoritesLib.formActions.favoritelist,
        userid: user_id,
        siteid: site_id,
        include_links: include_links,
        include_buttons: include_buttons,
        include_thumbnails: include_thumbnails,
        thumbnail_size: thumbnail_size,
        include_excerpt: include_excerpt,
        no_favorites: no_favorites,
        post_types: post_types,
      },
      success: function (data) {
        if (FavoritesLib.jsData.dev_mode) {
          console.log("Favorites list successfully retrieved.");
          console.log($(list));
          console.log(data);
        }
        var newlist = $(data.list);
        $(list).replaceWith(newlist);
        plugin.removeButtonLoading(newlist);
        $(document).trigger("favorites-list-updated", [newlist]);
      },
      error: function (data) {
        if (!FavoritesLib.jsData.dev_mode) return;
        console.log("There was an error updating the list.");
        console.log(list);
        console.log(data);
      },
      timeout: 10000, // sets timeout to 5 seconds
    });
  };

  /**
   * Remove loading state from buttons in the list
   */
  plugin.removeButtonLoading = function (list) {
    var buttons = $(list).find(FavoritesLib.selectors.button);
    $.each(buttons, function () {
      plugin.buttonFormatter.format($(this), false);
      $(this).removeClass(FavoritesLib.cssClasses.loading);
      $(this).removeClass(FavoritesLib.cssClasses.active);
      $(this).addClass(FavoritesLib.cssClasses.deactive);
    });
  };

  /**
   * Remove unfavorited items from the list
   */
  plugin.removeInvalidListItems = function (list, favorites) {
    var listitems = $(list).find("li[data-postid]");
    $.each(listitems, function (i, v) {
      var postid = $(this).attr("data-postid");
      if (!plugin.utilities.isFavorite(postid, favorites)) $(this).remove();
    });
  };

  return plugin.bindEvents();
};
/**
 * Favorite Buttons
 * Favorites/Unfavorites a specific post
 *
 * Events:
 * favorites-updated-single: A user's favorite has been updated. Params: favorites, post_id, site_id, status
 */
var FavoritesLib = FavoritesLib || {};

FavoritesLib.Button = function () {
  var plugin = this;
  var $ = jQuery;
  let isAjaxCallInProgress = false;

  plugin.activeButton; // The clicked button
  plugin.allButtons; // All favorite buttons for the current post
  plugin.authenticated = true;

  plugin.formatter = new FavoritesLib.Formatter();
  plugin.data = {};

  plugin.bindEvents = function () {
    $(document)
      .off("click", FavoritesLib.selectors.button)
      .on("click", FavoritesLib.selectors.button, function (e) {
        e.preventDefault();
        plugin.submitFavorite($(this));
      });
  };

  /**
   * Set all buttons
   */
  plugin.setAllButtons = function () {
    var post_id = $(plugin.activeButton).attr("data-postid");
    plugin.allButtons = $('.ug-favorit[data-postid="' + post_id + '"]');
  };

  /**
   * Set the Post Data
   */
  plugin.setData = function () {
    plugin.data.post_id = $(plugin.activeButton).attr("data-postid");
    plugin.data.site_id = $(plugin.activeButton).attr("data-siteid");
    plugin.data.status = $(plugin.activeButton).hasClass("active")
      ? "inactive"
      : "active";
    var consentProvided = $(plugin.activeButton).attr(
      "data-user-consent-accepted"
    );
    plugin.data.user_consent_accepted =
      typeof consentProvided !== "undefined" && consentProvided !== ""
        ? true
        : false;
  };

  /**
   * Submit the button
   */
  plugin.submitFavorite = function (elm) {
    if (isAjaxCallInProgress) {
      return; // Stop funktionen, hvis et kald allerede er aktivt
    }

    plugin.activeButton = elm;
    plugin.setAllButtons();

    // Sæt flaget til true, når kaldet startes
    isAjaxCallInProgress = true;

    plugin.activeButton.addClass("fa-beat-fade");
    plugin.setData();
    plugin.loading(true);
    var formData = {
      action: FavoritesLib.formActions.favorite,
      postid: plugin.data.post_id,
      siteid: plugin.data.site_id,
      status: plugin.data.status,
      user_consent_accepted: plugin.data.user_consent_accepted,
    };

    $.ajax({
      url: FavoritesLib.jsData.ajaxurl,
      type: "post",
      dataType: "json",
      data: formData,
      cache: false,
      success: function (data) {
        if (FavoritesLib.jsData.dev_mode) {
          console.log("The favorite was successfully saved.");
          console.log(data);
        }
        if (data.status === "unauthenticated") {
          FavoritesLib.authenticated = false;
          plugin.loading(false);
          plugin.data.status = "inactive";
          $(document).trigger("favorites-update-all-buttons");
          $(document).trigger("favorites-require-authentication", [
            plugin.data,
          ]);
          return;
        }
        if (data.status === "consent_required") {
          plugin.loading(false);
          $(document).trigger("favorites-require-consent", [
            data,
            plugin.data,
            plugin.activeButton,
          ]);
          return;
        }
        FavoritesLib.userFavorites = data.favorites;
        plugin.loading(false);
        plugin.resetButtons();

        const favoritesUpdated = new CustomEvent("favorite-status-changed", {
          detail: {
            favorites: [...Object.values(data.favorites[0].posts)],
            postId: plugin.data.post_id,
            siteId: plugin.data.site_id,
            status: plugin.data.status,
          },
        });

        document.dispatchEvent(favoritesUpdated);

        $(document).trigger("favorites-updated-single", [
          data.favorites,
          plugin.data.post_id,
          plugin.data.site_id,
          plugin.data.status,
        ]);
        $(document).trigger("favorites-update-all-buttons");

        // Deprecated callback
        favorites_after_button_submit(
          data.favorites,
          plugin.data.post_id,
          plugin.data.site_id,
          plugin.data.status
        );
      },
      error: function (data) {
        if (!FavoritesLib.jsData.dev_mode) return;
        console.log("There was an error saving the favorite.");
        console.log(data);
      },
      complete: function (data) {
        plugin.activeButton.removeClass("fa-beat-fade");
        isAjaxCallInProgress = false;
      },
      timeout: 10000,
    });
  };

  /*
   * Set the output html
   */
  plugin.resetButtons = function () {
    var favorite_count = parseInt(
      $(plugin.activeButton).attr("data-favoritecount")
    );

    $.each(plugin.allButtons, function () {
      if (plugin.data.status === "inactive") {
        if (favorite_count <= 0) favorite_count = 1;
        $(this).removeClass(FavoritesLib.cssClasses.active);
        $(this).addClass(FavoritesLib.cssClasses.deactive);
        $(this).attr("data-favoritecount", favorite_count - 1);
        $(this)
          .find(FavoritesLib.selectors.count)
          .text(favorite_count - 1);
        return;
      } else {
        $(this).addClass(FavoritesLib.cssClasses.active);
        $(this).removeClass(FavoritesLib.cssClasses.deactive);
        $(this).attr("data-favoritecount", favorite_count + 1);
        $(this)
          .find(FavoritesLib.selectors.count)
          .text(favorite_count + 1);
      }
    });
  };

  /*
   * Toggle loading on the button
   */
  plugin.loading = function (loading) {
    if (loading) {
      $.each(plugin.allButtons, function () {
        $(this).attr("disabled", "disabled");
        $(this).removeClass(FavoritesLib.cssClasses.active);
        $(this).removeClass(FavoritesLib.cssClasses.deactive);
        $(this).addClass(FavoritesLib.cssClasses.loading);
        // $(this).html(plugin.addLoadingIndication());
      });
    }
    {
      $.each(plugin.allButtons, function () {
        $(this).attr("disabled", false);
        $(this).removeClass(FavoritesLib.cssClasses.loading);
        $(this).addClass(FavoritesLib.cssClasses.deactive);
      });
    }
  };

  /*
   * Add loading indication to button
   */
  plugin.addLoadingIndication = function (html) {
    if (FavoritesLib.jsData.indicate_loading !== "1") return html;
    if (plugin.data.status === "active")
      return (
        FavoritesLib.jsData.loading_text +
        FavoritesLib.jsData.loading_image_active
      );
    return FavoritesLib.jsData.loading_text + FavoritesLib.jsData.loading_image;
  };

  return plugin.bindEvents();
};
/**
 * Updates Favorite Buttons as Needed
 */
var FavoritesLib = FavoritesLib || {};

FavoritesLib.ButtonUpdater = function () {
  var plugin = this;
  var $ = jQuery;

  plugin.utilities = new FavoritesLib.Utilities();
  plugin.formatter = new FavoritesLib.Formatter();
  plugin.buttonFormatter = new FavoritesLib.ButtonOptionsFormatter();

  plugin.activeButton;
  plugin.data = {};

  plugin.bindEvents = function () {
    $(document).on("favorites-update-all-buttons", function () {
      plugin.updateAllButtons();
    });
    $(document).on("favorites-list-updated", function (event, list) {
      //plugin.updateAllButtons(list);
    });

    document.addEventListener(
      "update-favorites",
      (_) => FavoritesLib.userFavorites && plugin.updateAllButtons()
    );
  };

  /*
   * Update all favorites buttons to match the user favorites
   * @param list object (optionally updates button in list)
   */
  plugin.updateAllButtons = function (list) {
    if (typeof FavoritesLib.userFavorites === "undefined") return;
    var buttons =
      typeof list === undefined && list !== ""
        ? $(list).find(FavoritesLib.selectors.button)
        : $(FavoritesLib.selectors.button);

    for (var i = 0; i < $(buttons).length; i++) {
      plugin.activeButton = $(buttons)[i];
      if (FavoritesLib.authenticated) plugin.setButtonData();

      if (
        FavoritesLib.authenticated &&
        plugin.utilities.isFavorite(
          plugin.data.postid,
          plugin.data.site_favorites
        )
      ) {
        plugin.buttonFormatter.format($(plugin.activeButton), true);
        $(plugin.activeButton).addClass(FavoritesLib.cssClasses.active);
        $(plugin.activeButton).removeClass(FavoritesLib.cssClasses.loading);
        $(plugin.activeButton)
          .find(FavoritesLib.selectors.count)
          .text(plugin.data.favorite_count);
        continue;
      }

      plugin.buttonFormatter.format($(plugin.activeButton), false);
      $(plugin.activeButton).removeClass(FavoritesLib.cssClasses.active);
      $(plugin.activeButton).removeClass(FavoritesLib.cssClasses.loading);
      $(plugin.activeButton).addClass(FavoritesLib.cssClasses.deactive);
      $(plugin.activeButton)
        .find(FavoritesLib.selectors.count)
        .text(plugin.data.favorite_count);
    }
  };

  /**
   * Set the button data
   */
  plugin.setButtonData = function () {
    plugin.data.postid = $(plugin.activeButton).attr("data-postid");
    plugin.data.siteid = $(plugin.activeButton).attr("data-siteid");
    plugin.data.favorite_count = $(plugin.activeButton).attr(
      "data-favoritecount"
    );
    plugin.data.site_index = plugin.utilities.siteIndex(plugin.data.siteid);
    plugin.data.site_favorites =
      FavoritesLib.userFavorites[plugin.data.site_index].posts;
    if (plugin.data.favorite_count <= 0) plugin.data.favorite_count = 0;
  };

  return plugin.bindEvents();
};
/**
 * Total User Favorites Count Updates
 */
var FavoritesLib = FavoritesLib || {};

FavoritesLib.TotalCount = function () {
  var plugin = this;
  var $ = jQuery;

  plugin.bindEvents = function () {
    $(document).on("favorites-updated-single", function () {
      plugin.updateTotal();
    });
    $(document).on("favorites-cleared", function () {
      plugin.updateTotal();
    });
    $(document).on("favorites-user-favorites-loaded", function () {
      plugin.updateTotal();
    });
  };

  /*
   * Update Total Number of Favorites
   */
  plugin.updateTotal = function () {
    // Loop through all the total favorite elements
    for (var i = 0; i < $(FavoritesLib.selectors.total_favorites).length; i++) {
      var item = $(FavoritesLib.selectors.total_favorites)[i];
      var siteid = parseInt($(item).attr("data-siteid"));
      var posttypes = $(item).attr("data-posttyper");
      var posttypes_array = posttypes.split(","); // Multiple Post Type Support
      var count = 0;

      // Loop through all sites in favorites
      for (var c = 0; c < FavoritesLib.userFavorites.length; c++) {
        var site_favorites = FavoritesLib.userFavorites[c];
        if (site_favorites.site_id !== siteid) continue;
        $.each(site_favorites.posts, function () {
          if ($(item).attr("data-posttyper") === "all") {
            count++;
            return;
          }
          if ($.inArray(this.post_type, posttypes_array) !== -1) count++;
        });
      }
      $(item).text(count);
    }
  };

  return plugin.bindEvents();
};
/**
 * Updates the count of favorites for a post
 */
var FavoritesLib = FavoritesLib || {};

FavoritesLib.PostFavoriteCount = function () {
  var plugin = this;
  var $ = jQuery;

  plugin.bindEvents = function () {
    $(document).on(
      "favorites-updated-single",
      function (event, favorites, post_id, site_id, status) {
        if (status === "active") return plugin.updateCounts();
        plugin.decrementSingle(post_id, site_id);
      }
    );
    $(document).on(
      "favorites-cleared",
      function (event, button, old_favorites) {
        plugin.updateCounts(old_favorites, true);
      }
    );
  };

  /*
   * Update Total Number of Favorites
   */
  plugin.updateCounts = function (favorites, decrement) {
    if (typeof favorites === "undefined" || favorites === "")
      favorites = FavoritesLib.userFavorites;
    if (typeof decrement === "undefined" || decrement === "") decrement = false;

    // Loop through all the total favorite elements
    for (
      var i = 0;
      i < $("[" + FavoritesLib.selectors.post_favorite_count + "]").length;
      i++
    ) {
      var item = $("[" + FavoritesLib.selectors.post_favorite_count + "]")[i];
      var postid = parseInt(
        $(item).attr(FavoritesLib.selectors.post_favorite_count)
      );
      var siteid = $(item).attr("data-siteid");
      if (siteid === "") siteid = "1";

      // Loop through all sites in favorites
      for (var c = 0; c < favorites.length; c++) {
        var site_favorites = favorites[c];
        if (site_favorites.site_id !== parseInt(siteid)) continue;
        $.each(site_favorites.posts, function () {
          if (this.post_id === postid) {
            if (decrement) {
              var count = parseInt(this.total) - 1;
              $(item).text(count);
              return;
            }
            $(item).text(this.total);
          }
        });
      }
    }
  };

  /**
   * Decrement a single post total
   */
  plugin.decrementSingle = function (post_id, site_id) {
    for (
      var i = 0;
      i < $("[" + FavoritesLib.selectors.post_favorite_count + "]").length;
      i++
    ) {
      var item = $("[" + FavoritesLib.selectors.post_favorite_count + "]")[i];
      var item_post_id = $(item).attr(
        FavoritesLib.selectors.post_favorite_count
      );
      var item_site_id = $(item).attr("data-siteid");
      if (item_site_id === "") item_site_id = "1";
      if (item_site_id !== site_id) continue;
      if (item_post_id !== post_id) continue;
      var count = parseInt($(item).text()) - 1;
      $(item).text(count);
    }
  };

  return plugin.bindEvents();
};
/**
 * Favorites Require Authentication
 */
var FavoritesLib = FavoritesLib || {};

FavoritesLib.RequireAuthentication = function () {
  var plugin = this;
  var $ = jQuery;

  plugin.bindEvents = function () {
    $(document).on("favorites-require-authentication", function () {
      if (FavoritesLib.jsData.dev_mode) {
        console.log("Unauthenticated user was prevented from favoriting.");
      }
      if (FavoritesLib.jsData.authentication_redirect) {
        plugin.redirect();
        return;
      }
      plugin.openModal();
    });
    $(document).on("click", ".simplefavorites-modal-backdrop", function (e) {
      plugin.closeModal();
    });
    $(document).on(
      "click",
      "[" + FavoritesLib.selectors.close_modals + "]",
      function (e) {
        e.preventDefault();
        plugin.closeModal();
      }
    );
  };

  /**
   * Redirect to a page
   */
  plugin.redirect = function () {
    window.location = FavoritesLib.jsData.authentication_redirect_url;
  };

  /**
   * Open the Modal
   */
  plugin.openModal = function () {
    plugin.buildModal();
    setTimeout(function () {
      $("[" + FavoritesLib.selectors.modals + "]").addClass("active");
    }, 10);
  };

  /**
   * Build the Modal
   */
  plugin.buildModal = function () {
    var modal = $("[" + FavoritesLib.selectors.modals + "]");
    if (modal.length > 0) return;
    var html =
      '<div class="simplefavorites-modal-backdrop" ' +
      FavoritesLib.selectors.modals +
      "></div>";
    html +=
      '<div class="simplefavorites-modal-content" ' +
      FavoritesLib.selectors.modals +
      ">";
    html += '<div class="simplefavorites-modal-content-body">';
    html += FavoritesLib.jsData.authentication_modal_content;
    html += "</div><!-- .simplefavorites-modal-content-body -->";
    html += "</div><!-- .simplefavorites-modal-content -->";
    $("body").prepend(html);
  };

  /**
   * Close the Moda
   */
  plugin.closeModal = function () {
    $("[" + FavoritesLib.selectors.modals + "]").removeClass("active");
    $(document).trigger("favorites-modal-closed");
  };

  return plugin.bindEvents();
};
/**
 * Favorites Require Consent Modal Agreement
 */
var FavoritesLib = FavoritesLib || {};

FavoritesLib.RequireConsent = function () {
  var plugin = this;
  var $ = jQuery;

  plugin.consentData;
  plugin.postData;
  plugin.activeButton;

  plugin.bindEvents = function () {
    $(document).on(
      "favorites-require-consent",
      function (event, consent_data, post_data, active_button) {
        plugin.consentData = consent_data;
        plugin.postData = post_data;
        plugin.activeButton = active_button;
        plugin.openModal();
      }
    );
    $(document).on("favorites-user-consent-approved", function (e, button) {
      if (typeof button !== "undefined") {
        $(plugin.activeButton).attr("data-user-consent-accepted", "true");
        $(plugin.activeButton).click();
        plugin.closeModal();
        return;
      }
      plugin.setConsent(true);
    });
    $(document).on("favorites-user-consent-denied", function () {
      plugin.setConsent(false);
    });
    $(document).on("click", ".simplefavorites-modal-backdrop", function (e) {
      plugin.closeModal();
    });
    $(document).on("click", "[data-favorites-consent-deny]", function (e) {
      e.preventDefault();
      plugin.closeModal();
      $(document).trigger("favorites-user-consent-denied");
    });
    $(document).on("click", "[data-favorites-consent-accept]", function (e) {
      e.preventDefault();
      $(document).trigger("favorites-user-consent-approved", [$(this)]);
    });
  };

  /**
   * Open the Modal
   */
  plugin.openModal = function () {
    plugin.buildModal();
    setTimeout(function () {
      $("[" + FavoritesLib.selectors.consentModal + "]").addClass("active");
    }, 10);
  };

  /**
   * Build the Modal
   */
  plugin.buildModal = function () {
    var modal = $("[" + FavoritesLib.selectors.consentModal + "]");
    if (modal.length > 0) return;
    var html =
      '<div class="simplefavorites-modal-backdrop" ' +
      FavoritesLib.selectors.consentModal +
      "></div>";
    html +=
      '<div class="simplefavorites-modal-content" ' +
      FavoritesLib.selectors.consentModal +
      ">";
    html += '<div class="simplefavorites-modal-content-body no-padding">';
    html += '<div class="simplefavorites-modal-content-interior">';
    html += plugin.consentData.message;
    html += "</div>";
    html += '<div class="simplefavorites-modal-content-footer">';
    html +=
      '<button class="simplefavorites-button-consent-deny" data-favorites-consent-deny>' +
      plugin.consentData.deny_text +
      "</button>";
    html +=
      '<button class="simplefavorites-button-consent-accept" data-favorites-consent-accept>' +
      plugin.consentData.accept_text +
      "</button>";
    html += "</div><!-- .simplefavorites-modal-footer -->";
    html += "</div><!-- .simplefavorites-modal-content-body -->";
    html += "</div><!-- .simplefavorites-modal-content -->";
    $("body").prepend(html);
  };

  /**
   * Close the Modal
   */
  plugin.closeModal = function () {
    $("[" + FavoritesLib.selectors.consentModal + "]").removeClass("active");
  };

  /**
   * Submit a manual deny/consent
   */
  plugin.setConsent = function (consent) {
    $.ajax({
      url: FavoritesLib.jsData.ajaxurl,
      type: "post",
      dataType: "json",
      data: {
        action: FavoritesLib.formActions.cookieConsent,
        consent: consent,
      },
      timeout: 10000, // sets timeout to 5 seconds
    });
  };

  return plugin.bindEvents();
};
/**
 * Primary Favorites Initialization
 * @package Favorites
 * @author Kyle Phillips - https://github.com/kylephillips/favorites
 *
 * Events:
 * favorites-nonce-generated: The nonce has been generated
 * favorites-updated-single: A user's favorite has been updated. Params: favorites, post_id, site_id, status
 * favorites-cleared: The user's favorites have been cleared. Params: clear button
 * favorites-user-favorites-loaded: The user's favorites have been loaded. Params: intialLoad (bool)
 * favorites-require-authentication: An unauthenticated user has attempted to favorite a post (The Require Login & Show Modal setting is checked)
 */

/**
 * Callback Functions for use in themes (deprecated in v2 in favor of events)
 */
function favorites_after_button_submit(favorites, post_id, site_id, status) {}
function favorites_after_initial_load(favorites) {}

/** Init sker i visning.js
jQuery(document).ready(function(){
	new Favorites.Factory;
});
*/

var FavoritesLib = FavoritesLib || {};

/**
 * DOM Selectors Used by the Plugin
 */
FavoritesLib.selectors = {
  button: ".ug-favorit", // Favorite Buttons
  list: ".favorites-list", // Favorite Lists
  clear_button: ".simplefavorites-clear", // Clear Button
  total_favorites: ".simplefavorites-user-count", // Total Favorites (from the_user_favorites_count)
  modals: "data-favorites-modal", // Modals
  consentModal: "data-favorites-consent-modal", // Consent Modal
  close_modals: "data-favorites-modal-close", // Link/Button to close the modals
  count: ".simplefavorite-button-count", // The count inside the favorites button
  post_favorite_count: "data-favorites-post-count-id", // The total number of times a post has been favorited
};

/**
 * CSS Classes Used by the Plugin
 */
FavoritesLib.cssClasses = {
  loading: "loading", // Loading State
  active: "active", // Active State
  deactive: "deactive", // non Active State
};

/**
 * Localized JS Data Used by the Plugin
 */
// Favorites.jsData = {
//   // ajaxurl: favorites_data.ajaxurl, // The WP AJAX URL
//   // favorite: favorites_data.favorite, // Active Button Text/HTML
//   // favorited: favorites_data.favorited, // Inactive Button Text
//   // include_count: favorites_data.includecount, // Whether to include the count in buttons
//   // indicate_loading: favorites_data.indicate_loading, // Whether to include loading indication in buttons
//   // loading_text: favorites_data.loading_text, // Loading indication text
//   // loading_image_active: favorites_data.loading_image_active, // Loading spinner url in active button
//   // loading_image: favorites_data.loading_image, // Loading spinner url in inactive button
//   // cache_enabled: favorites_data.cache_enabled, // Is cache enabled on the site
//   // authentication_modal_content: favorites_data.authentication_modal_content, // Content to display in authentication gate modal
//   // authentication_redirect: favorites_data.authentication_redirect, // Whether to redirect unauthenticated users to a page
//   // authentication_redirect_url: favorites_data.authentication_redirect_url, // URL to redirect to
//   // button_options: favorites_data.button_options, // Custom button options
//   // dev_mode: favorites_data.dev_mode, // Is Dev mode enabled
//   // logged_in: favorites_data.logged_in, // Is the user logged in
//   // user_id: favorites_data.user_id, // The current user ID (0 if logged out)
// };
FavoritesLib.LoadGlobalSettings = function () {
  FavoritesLib.jsData = {
    ajaxurl: favorites_data.ajaxurl, // The WP AJAX URL
    favorite: favorites_data.favorite, // Active Button Text/HTML
    favorited: favorites_data.favorited, // Inactive Button Text
    include_count: favorites_data.includecount, // Whether to include the count in buttons
    indicate_loading: favorites_data.indicate_loading, // Whether to include loading indication in buttons
    loading_text: favorites_data.loading_text, // Loading indication text
    loading_image_active: favorites_data.loading_image_active, // Loading spinner url in active button
    loading_image: favorites_data.loading_image, // Loading spinner url in inactive button
    cache_enabled: favorites_data.cache_enabled, // Is cache enabled on the site
    authentication_modal_content: favorites_data.authentication_modal_content, // Content to display in authentication gate modal
    authentication_redirect: favorites_data.authentication_redirect, // Whether to redirect unauthenticated users to a page
    authentication_redirect_url: favorites_data.authentication_redirect_url, // URL to redirect to
    button_options: favorites_data.button_options, // Custom button options
    dev_mode: favorites_data.dev_mode, // Is Dev mode enabled
    logged_in: favorites_data.logged_in, // Is the user logged in
    user_id: favorites_data.user_id, // The current user ID (0 if logged out)
  };
};

/**
 * The user's favorites
 * @var object
 */
FavoritesLib.userFavorites = null;

/**
 * Is the user authenticated
 * @var object
 */
FavoritesLib.authenticated = true;

/**
 * WP Form Actions Used by the Plugin
 */
FavoritesLib.formActions = {
  favoritesarray: "favorites_array",
  favorite: "favorites_favorite",
  clearall: "favorites_clear",
  favoritelist: "favorites_list",
  cookieConsent: "favorites_cookie_consent",
};

/**
 * Primary factory class
 */
FavoritesLib.Factory = function () {
  var plugin = this;
  var $ = jQuery;

  FavoritesLib.LoadGlobalSettings();

  plugin.build = function () {
    new FavoritesLib.UserFavorites();
    new FavoritesLib.Lists();
    new FavoritesLib.Clear();
    new FavoritesLib.Button();
    new FavoritesLib.ButtonUpdater();
    new FavoritesLib.TotalCount();
    new FavoritesLib.PostFavoriteCount();
    new FavoritesLib.RequireAuthentication();
    new FavoritesLib.RequireConsent();
  };

  return plugin.build();
};
